/* eslint-disable */
import { produce } from "immer";
import {
  GRADES_FETCH_START,
  GRADES_FETCH_SUCCESS,
  GRADES_FETCH_FAILURE,
} from "../actions/types";

const grades = (
  state = {
    gradesFetching: false,
    gradesData: [],
    gradesError: null,
  },
  action,
) => {
  switch (action.type) {
    case GRADES_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case GRADES_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case GRADES_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default grades;
